import { ReactNode, Ref } from 'react';
import { twMerge } from 'tailwind-merge';
import { Heading, HeadingProps } from 'react-aria-components';

export interface SectionTitleProps extends HeadingProps {
  title: string;
  children?: ReactNode;
  className?: string;
  titleClassName?: string;
  /** Optional ref to the rendered heading element */
  headingRef?: Ref<HTMLHeadingElement>;
}

const SectionTitle = ({
  title,
  level = 2,
  className,
  titleClassName,
  children,
  headingRef,
}: SectionTitleProps) => {
  return (
    <div
      className={twMerge(
        'flex flex-row items-center justify-between gap-2.5 pb-2 px-6',
        className
      )}
    >
      <Heading
        ref={headingRef}
        level={level}
        className={twMerge(
          'text-2xl text-surface-75 font-bold',
          titleClassName
        )}
      >
        {title}
      </Heading>
      {children}
    </div>
  );
};

export default SectionTitle;
